import React from "react";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const LogoLinkedIn = ({
  height = normalize(24),
  width = normalize(24),
  ...props
}) => (
  <Svg width={width} height={height} viewBox="0 0 24 24" {...props}>
    <Path
      d="M18.222 4A1.778 1.778 0 0 1 20 5.778v12.444A1.778 1.778 0 0 1 18.222 20H5.778A1.778 1.778 0 0 1 4 18.222V5.778A1.778 1.778 0 0 1 5.778 4h12.444Zm-.444 13.778v-4.711a2.898 2.898 0 0 0-2.898-2.898c-.756 0-1.636.462-2.062 1.155v-.986h-2.48v7.44h2.48v-4.382a1.24 1.24 0 1 1 2.48 0v4.382h2.48ZM7.448 8.942A1.493 1.493 0 0 0 8.943 7.45c0-.827-.666-1.502-1.493-1.502a1.502 1.502 0 0 0-1.502 1.502c0 .827.675 1.493 1.502 1.493Zm1.236 8.836v-7.44H6.222v7.44h2.462Z"
      fill="#0077B7"
    />
  </Svg>
);

export default LogoLinkedIn;
